import { useQuery } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

export const memberRequestDetailKeys = {
  detail: (id) => ['memberRequest', 'detail', id],
};

export const useMemberRequestDetail = (requestId) => {
  return useQuery({
    queryKey: memberRequestDetailKeys.detail(requestId),
    queryFn: async () => {
      const result = await serverRequest(
        'GET',
        `members/gcb/request/${requestId}`
      );
      return result.data;
    },
    enabled: !!requestId,
    onError: (error) => {
      notifyUser('error', error, 'Error');
    },
  });
};
